module.exports = __webpack_public_path__ + "img/tongji.2e7d128a.png";